import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LobbyService } from '../../../shared/services/lobby.service';
import { getImpersonateUserDetails, getShouldPromptImpersonationPoup } from 'src/app/lobby/lobby-staff-status/state/selectors/lobby-staff-status.selector';
import * as LobbyStaffStatusActions from 'src/app/lobby/lobby-staff-status/state/actions/lobby-staff-status.actions';

import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { Subscription } from 'rxjs';
import { ImpersonateUserModel } from 'src/app/lobby/lobby-staff-status/shared/models/impersonate-user.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as LobbyWrapUpPageActions from '../../../lobby-wrap-up/state/actions/wrap-up-page.actions';
import { getLobbyShowCategory } from 'src/app/state';
@Component({
  selector: 'app-impersonate-assist',
  templateUrl: './impersonate-assist.component.html',
  styleUrls: ['./impersonate-assist.component.scss']
})
export class ImpersonateAssistComponent implements OnInit {

  @ViewChild('popupModal') public modal: any;
  @Input() public dialogOpened?: boolean;
  @Input() public message?: string;
  @Input() public header?: string;
  
  /*
  -- Two way binding convention --
  Output property was not used earlier even thought two-way syntax 
  is used in the template, and it's unclear if an event is emitted 
  when `locationId` changes. Since 2-way binding was used, the 
  output property is added below to comply.
  */
  @Input() public locationId: number = 0;
  @Output() public locationIdChange = new EventEmitter<number>();

  // Same reasoning as above
  @Input() public lobbyEntry?: any;
  @Output() public lobbyEntryChange = new EventEmitter<any>();

  // End

  @Input() public actionYesLabel?: string;
  @Input() public actionNoLabel?: string;
  @Input() public isInfo = false;
  @Output() public submitted = new EventEmitter();
  @Output() public cancelled = new EventEmitter();
  public impersonateAssistUserName: string | null = null;
  public impersonateAssistUserCode: string | null = null;
  userDetails: ImpersonateUserModel[] | null = [];
  lobbyImpersonateForm: FormGroup = {} as FormGroup;
  private subscriptions: Subscription = new Subscription();
  showLobbyCateogory: boolean = false;

  public unableToImpersonate: boolean = false;
  public showDifferentPersonRequested: boolean = false;
  public impersonateAssistUserId: number = 0;
  constructor(public lobbyService: LobbyService, public toastService: ToastService, private store: Store<State>, private fb: FormBuilder) { }

  ngOnInit() {
    this.lobbyImpersonateForm = this.fb.group({
      assistAsUser: ['-1', [Validators.required, Validators.pattern(/^[1-9]+[0-9]*$/)]],
    });

    const impersonationUserDetailSubscription = this.store.select(getImpersonateUserDetails)
      .subscribe((userinfo) => {
        this.userDetails = userinfo;
        if (this.userDetails != null && this.userDetails.length < 1 && this.dialogOpened == true) {

          this.unableToImpersonate = true;
          this.dialogOpened = false;
        }
        this.lobbyImpersonateForm.controls.assistAsUser.setValue("-1");
        this.lobbyImpersonateForm.markAsUntouched();

      })
    const promptImpersonationPopupSubscription = this.store.select(getShouldPromptImpersonationPoup)
      .subscribe((isShowPopup) => {
        this.dialogOpened = isShowPopup;
        if (this.userDetails != null && this.userDetails.length < 1 && this.dialogOpened == true) {

          this.unableToImpersonate = true;
          this.store.dispatch(LobbyStaffStatusActions.promptImpersonatePopup({ open: false }));
        }


      });
    const getLobbyCategorySub = this.store.select(getLobbyShowCategory).subscribe((lobbyCategory) => {

      this.showLobbyCateogory = lobbyCategory;

    });
  
    this.subscriptions.add(impersonationUserDetailSubscription);
    this.subscriptions.add(promptImpersonationPopupSubscription);
    this.subscriptions.add(getLobbyCategorySub);
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public close(component: string) {
    this.cancelled.emit();
    (this as any)[component + 'Opened'] = false;
    this.store.dispatch(LobbyStaffStatusActions.promptImpersonatePopup({ open: false }));
  }
  public closeUnableToImpersonate() {
    this.unableToImpersonate = false;
    this.store.dispatch(LobbyStaffStatusActions.promptImpersonatePopup({ open: false }));
  }

  public open(component: string) {
    (this as any)[component + 'Opened'] = true;
    this.dialogOpened = true;
  }

  public action(status: string) {
    console.log(`Dialog result: ${status}`);
    this.dialogOpened = false;
  }

  public emitSubmit(state: string): void {
    this.impersonateAssistUserId = this.lobbyImpersonateForm.controls.assistAsUser.value;
    
    if (this.userDetails != null) {
      this.impersonateAssistUserName = this.userDetails?.find(x => x.userId == this.impersonateAssistUserId)?.firstName + " " + this.userDetails?.find(x => x.userId == this.impersonateAssistUserId)?.lastName;
      this.impersonateAssistUserCode = this.userDetails?.find(x => x.userId == this.impersonateAssistUserId)?.userCode?.toString() ?? null;
    }
    
    this.store.dispatch(LobbyStaffStatusActions.promptImpersonatePopup({ open: false }));

    if (this.lobbyEntry.personRequestedId != null && this.lobbyEntry.personRequestedId != this.impersonateAssistUserId) {
      this.showDifferentPersonRequested = true;
    } else {
      this.impersonateAssist();
    }

    this.submitted.emit();
  }

  public impersonateAssist() {
    this.store.dispatch(LobbyWrapUpPageActions.impersonateAssistLobbyEntry({
      payload: {
        LobbyEntryId: this.lobbyEntry.lobbyEntryId,
        UserId: this.impersonateAssistUserId,
        LocationId: this.locationId ?? 0,
        ShowLobbyCategory: this.showLobbyCateogory,
        impersonatedById: null,
        impersonatedByName: this.impersonateAssistUserName,
        impersonatedByCode: this.impersonateAssistUserCode 
      }

    }));
    this.showDifferentPersonRequested = false;
  }
  public closeDifferentPersonRequestedPopup() {
    this.showDifferentPersonRequested = false;
  }

  public emitCancel(state: string): void {
    this.cancelled.emit();
    this.store.dispatch(LobbyStaffStatusActions.promptImpersonatePopup({ open: false }));

  }

}
